import React, { Component } from "react";

class Contact extends Component {
  render() {
    return (
      <div className="main-content">
        <div className="contact-container">
          <div className="sec-banner">
            <div className="overlay" />
            <h2>CONTACT US</h2>
          </div>
          <h2>Get in touch</h2>
          <p>We will get back to you within 2 - 3 business days</p>
          <div className="contact-inputs">
            <div className="input-container">
              <input type="text" placeholder="Your Name" />
            </div>
            <div className="input-container">
              <input type="text" placeholder="E-mail" />
            </div>
            <div className="input-container">
              <input type="text" placeholder="Phone" />
            </div>
          </div>
          <textarea type="text" placeholder="Message" />
          <div className="action-btn">
            <button>Submit</button>
          </div>
        </div>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js